import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useMyCollections } from "@/features/collections/use-collections";
import { NewCollectionDialog } from "@/features/collections/NewCollectionDialog";
import { CollectionCard } from "@/components/lovd/CollectionCard";

export default function CollectionsPage() {
  const { collections, type } = useMyCollections();
  const [creating, setCreating] = useState(false);

  return (
    <div className="mx-auto max-w-5xl px-8 py-10">
      <header className="mb-8 flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Collections</h1>
          <p className="text-sm text-muted-foreground">
            Group photos and memories together.
          </p>
        </div>
        <Button onClick={() => setCreating(true)}>
          <Plus className="mr-1 h-4 w-4" />
          New collection
        </Button>
      </header>

      {type === "unknown" && collections.length === 0 ? (
        <Grid>
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-48 rounded-xl" />
          ))}
        </Grid>
      ) : collections.length === 0 ? (
        <div className="rounded-xl border border-dashed border-border bg-muted/20 p-16 text-center">
          <p className="text-sm text-muted-foreground">
            You don't have any collections yet.
          </p>
          <Button className="mt-4" onClick={() => setCreating(true)}>
            <Plus className="mr-1 h-4 w-4" />
            Create your first collection
          </Button>
        </div>
      ) : (
        <Grid>
          {collections.map((c) => (
            <CollectionCard key={c.id} collection={c} />
          ))}
        </Grid>
      )}

      <NewCollectionDialog open={creating} onOpenChange={setCreating} />
    </div>
  );
}

function Grid({ children }: { children: React.ReactNode }) {
  return (
    <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {children}
    </ul>
  );
}
